/**
 * Metrik açıklamalarını biçimlendirmek için yardımcı fonksiyon
 * @param {string} text - Biçimlendirilecek metin
 * @returns {string} - Biçimlendirilmiş metin
 */
export const formatDescription = (text) => {
  if (!text) return '';
  const words = text.split(' ');
  let formattedDesc = '';
  
  for (let i = 0; i < words.length; i++) {
    formattedDesc += words[i];
    if ((i + 1) % 3 === 0 && i !== words.length - 1) {
      formattedDesc += '\n';
    } else if (i !== words.length - 1) {
      formattedDesc += ' ';
    }
  }
  
  return formattedDesc;
};

/**
 * Sütun başlıklarını biçimlendirmek için yardımcı fonksiyon
 * @param {string} text - Biçimlendirilecek metin
 * @returns {string} - Biçimlendirilmiş metin
 */
export const formatColumnHeader = (text) => {
  if (!text) return '';
  
  const words = text.split(' ');
  
  if (words.length <= 2) {
    return text; // İki kelime veya daha az ise değiştirme
  }
  
  // İlk iki kelimeyi al ve geri kalanı alt satıra geçir
  const firstPart = words.slice(0, 2).join(' ');
  const secondPart = words.slice(2).join(' ');
  
  return `${firstPart}<br>${secondPart}`;
};

/**
 * Para birimi koduna göre sembol döndürür
 * @param {string} currency - Para birimi kodu (TRY, USD, EUR, GBP)
 * @returns {string} - Para birimi sembolü
 */
export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case 'CAD':
      return '$';
    case 'AUD':
      return '$';
    case 'NZD':
      return '$';
    case 'CHF':
      return '$';
    case 'HKD':
      return '$';
    case 'SGD':
      return '$';
    case 'JPY':
      return '¥';
    case 'CNY':
      return '¥';
    case 'INR':
      return '₹';
    case 'RUB':
      return '₽';
    case 'BRL':
      return 'R$';
    case 'ARS':
      return '$';
    case 'RON':
      return 'lei';
    case 'MXN':
      return '$';
    case 'ZAR':
      return 'R';
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    case 'TRY':
    default:
      return '₺';
  }
};

/**
 * Percentage değerini tutarlı bir şekilde formatlar
 * Bu fonksiyon tüm percentage formatlamalarında kullanılmalı
 * @param {string|number} value - Formatlanacak değer
 * @returns {string} - Formatlanmış percentage değeri (100 ile çarpılıp % işareti ile)
 */
export const formatPercentageValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  
  // String'i sayıya çevir
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return value; // Sayı değilse orijinal değeri döndür
  
  // Eğer değer zaten % içeriyorsa, % sembolünü çıkar
  let cleanValue = numValue;
  if (String(value).includes('%')) {
    cleanValue = numValue; // % varsa sadece sayısal kısmı al
  }
  
  // SAYISAL DEĞERİ 100 İLE ÇARPIP % İŞARETİ İLE GÖSTER
  // 0.79 -> 79%, 0.25 -> 25%, 1.5 -> 150%
  const percentageValue = cleanValue * 100;
  return percentageValue.toLocaleString('tr-TR') + '%';
};

/**
 * Metrik değerini veri tipine göre biçimlendirir
 * @param {string|number} value - Biçimlendirilecek değer
 * @param {string} dataType - Veri tipi ('text', 'currency', 'percentage' vb.)
 * @param {string} currency - Para birimi kodu (TRY, USD, EUR, GBP)
 * @returns {string} - Biçimlendirilmiş değer
 */
export const formatMetricValue = (value, dataType, currency = 'TRY') => {
  if (value === null || value === undefined) return '-';
  
  switch (dataType) {
    case 'text':
      return String(value).length > 42 ? String(value).substring(0, 42) + '...' : String(value);
    
    case 'currency':
      return Math.round(parseFloat(value)).toLocaleString('tr-TR') + ' ' + getCurrencySymbol(currency);
    
    case 'percentage':
      return formatPercentageValue(value);
    
    default:
      return parseFloat(value).toLocaleString('tr-TR');
  }
}; 